import {IModulesState,IMODULEActionCreator,IModuleActionTypes} from 'models/IModules';

const initialState:IModulesState[] = []

const reducer = (state = initialState, { type, payload }: IMODULEActionCreator) => {
    switch (type) {
      case IModuleActionTypes.FETCH_MODULE_LIST_REQUEST:
        return {
          ...state,
          data:[],
        }
      case IModuleActionTypes.FETCH_MODULE_LIST_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;